import React from 'react';
import e1 from '../../../assets/home-feature/hfp1.png';
import e2 from '../../../assets/home-feature/hfp2.png';
import e3 from '../../../assets/home-feature/hfp3.png';
import e4 from '../../../assets/home-feature/hfp4.png';
import { Link } from 'react-router-dom';
import divider from '../../../assets/divider-img.png';

const allGalleryItems = [
  {
    id: 1,
    category: 'Cryptocurrencies',
    imageSrc: e1,
    linkTo: '',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 2,
    category: 'Stock',
    imageSrc: e2,
    linkTo: '',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 3,
    category: 'Forex',
    imageSrc: e3,
    linkTo: '',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 4,
    category: 'Cryptocurrencies',
    imageSrc: e4,
    linkTo: '',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];
const ProjectDetails = () => {
  return (
    <React.Fragment>
      <div className="services-banner project-details-banner">
        <div className="container">
          <div className="services-banner-wrapper project-details-banner-text">
            <h1>Gold Trading Bot</h1>
          </div>
        </div>
      </div>
      <div className="blur-effect"></div>
      <div className="container">
        <div className="project-details-inner">
          <h2>Project Detail</h2>
          <div className="project-details-inner-wrapper">
            <div className="details-textual">
              <p>
                The algorithmic trading bot for gold is a custom-built solution
                designed to execute trades based on a sophisticated strategy
                that incorporates Supertrend, ADX (Average Directional Index),
                EMA (Exponential Moving Average), and price action indicators.
                The primary goal of the bot is to automate the trading process
                and capitalize on potential opportunities in the gold market.
                One of the key features of the bot is its automatic lot size
                calculator, which allows traders to open positions based on a
                pre-set percentage of their equity. This feature ensures that
                the position sizes are proportionate to the trader's account
                size, promoting efficient risk management and capital
                preservation. The bot also includes a trailing stop-loss
                feature, which dynamically adjusts the stop-loss level as the
                trade moves in the trader's favor. This helps lock in profits
                while allowing room for potential further gains. Efficient
                portfolio management techniques are employed to optimize
                risk-reward ratios and diversify the trading strategy, enhancing
                overall performance The bot's logic is implemented using Python
                and leverages popular libraries such as Pandas and NumPy for
                efficient data manipulation and analysis. These libraries enable
                the bot to process historical and real-time market data to make
                informed decisions. The strategy behind the bot relies on
                several technical indicators to identify favorable entry and
                exit points. The Supertrend indicator helps determine the trend
                direction, while ADX measures the strength of the trend. EMA is
                utilized to smooth out price movements and provide additional
                insights into market conditions. Price action analysis is
                incorporated to consider the actual price behavior and patterns
                that can affect the trading decisions. Due to the limitations of
                Metatrader 4 (MT5) not supporting Python API, the developers
                used ZeroMQ to establish a bridge between MT5 and MT4. MT5 has a
                Python API, making it possible to connect the algorithmic
                trading bot to the MT4 platform. This bridge allows the bot to
                send signals and execute trades on the MT4 platform while
                keeping the analysis and decision-making process in Python. The
                trading bot aims to automate the entire trading process,
                including signal generation, position management, and trade
                execution. By utilizing a combination of technical indicators
                and price action analysis, the bot aims to make data-driven
                trading decisions to increase the chances of profitable trades
                in the gold market.
              </p>
              <h3>Note:</h3>
              <p>
                The effectiveness and success of any trading strategy, including
                the one described above, depend on various factors, including
                market conditions, risk management, and continuous optimization
                and improvement of the algorithm. Trading in financial markets
                carries inherent risks, and past performance is not indicative
                of future results. Always perform thorough backtesting and
                consider seeking advice from financial experts before using any
                algorithmic trading solution.
              </p>
            </div>
            <div className="details-visual">
              <div className="visual-details-top"></div>
              <div className="visual-details-bottom">
                <div className="bottom-details-inner m-r"></div>
                <div className="bottom-details-inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="project-nested-page">
          <h2>Featured Projects</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Welcome to our Algorithmic Trading service, where cutting-edge
            technology meets <br /> the financial markets. Our automated trading
            strategies leverag
          </p>
        </div>
        <div className="projects-gallery featured-projects-gallery">
          {allGalleryItems.map((item) => (
            <Link key={item.id} to={item.linkTo} className="gallery-item">
              <div className="slide expert feature portfolio-items">
                <div className="slide-content expert-content feature-content">
                  <img src={item.imageSrc} alt="experts" />
                  <div className="slide-info expert-info feature-info">
                    <h5>{item.category}</h5>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProjectDetails;
